module.exports = __webpack_public_path__ + "img/no-search.9e165664.svg";